import ReactGA from "react-ga4";
export default class GoogleAnalytics {
    static hasCustomTrackingId() {
        if (!session || !session.store) {
            return false;
        }
        const trackingId = session.store.custom_tracking_id;
        if (trackingId === null || typeof trackingId === 'undefined') {
            return false;
        }
        if (typeof trackingId === 'string') {
            return trackingId.trim().length > 0;
        }
        return true;
    }

    static start() {
        let initialize_array = [];
        if (this.hasCustomTrackingId()) {
            initialize_array.push({
                trackingId: session.store.custom_tracking_id,
                // gaOptions: {
                //     debug_mode: true,
                // },
                // gtagOptions: {
                //     debug_mode: true,
                // }
            });
            ReactGA.initialize(initialize_array);
        }
    }
    static recordPageView() {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname, title:  window.location.pathname});
        if (window.location.pathname.includes('cart')) {
            this.viewCart();
        }
    }

    static viewItem(item) {
        if (!this.hasCustomTrackingId()) {
            return;
        }
        ReactGA.event({
            category: 'ecommerce',
            action: 'view_item',
            label: item.name,
            value: item.price,
            item_id: item.id,
            item_category: item.category
        });
    }

    static addToCart(item,addons) {
        if (!this.hasCustomTrackingId()) {
            return;
        }
        ReactGA.event({
            category: 'ecommerce',
            action: 'add_to_cart',
            label: item.name,
            value: item.price,
            item_id: item.id,
            item_category: item.category,
            quantity: item.quantity
        });
    }

    static removeFromCart(item) {
        if (!this.hasCustomTrackingId()) {
            return;
        }
        ReactGA.event({
            category: 'ecommerce',
            action: 'remove_from_cart',
            label: item.name,
            value: item.price,
            item_id: item.id,
            quantity: item.quantity
        });
    }

    static viewCart(viewCartCallback = () => {}) {
        if (!this.hasCustomTrackingId()) {
            viewCartCallback();
            return;
        }
        ReactGA.event({
            category: 'Ecommerce',
            action: 'view_cart'
        });

        viewCartCallback();
    }

    static viewCheckout() {
        if (!this.hasCustomTrackingId()) {
            return;
        }

        ReactGA.event({
            category: "ecommerce",
            action: "view_checkout",
        });
    }

    static completePurchase(order) {
        if (!this.hasCustomTrackingId()) {
            return;
        }
        const orderLines = order.order_lines || order.lines || [];
        const orderValue = typeof order.total !== 'undefined' ? order.total : order.subtotal;
        ReactGA.event("purchase",{
            category: 'ecommerce',
            action: 'purchase',
            transaction_id: order.reference.toString(),
            value: orderValue,
            tax: order.tax,
            shipping: order.delivery_fee,
            currency: 'USD',
            items: orderLines.map(line => ({
                item_id: line.item_id,
                item_name: line.name,
                price: line.total,
                quantity: line.quantity
            }))
        });
    }

    static orderComplete(order = null) {
        this.completePurchase(order);
        if (!this.hasCustomTrackingId()) {
            return;
        }

        const transactionId = order && order.reference ? String(order.reference) : undefined;
        const orderLines = order.order_lines || order.lines || [];
        const orderValue = typeof order.total !== 'undefined' ? order.total : order.subtotal;

        ReactGA.event({
            category: "ecommerce",
            action: "order_complete",
            transaction_id: transactionId,
            value: orderValue,
            tax: order.tax,
            shipping: order.delivery_fee,
            currency: 'USD',
            items: orderLines.map(line => ({
                item_id: line.item_id,
                item_name: line.name,
                price: line.total,
                quantity: line.quantity
            }))
        });
    }

    static viewCategory(categoryName) {
        if (!this.hasCustomTrackingId()) {
            return;
        }
        ReactGA.event({
            category: 'ecommerce',
            action: 'view_category',
            value: categoryName
        })
    }

    static userSignUp() {
        if (!this.hasCustomTrackingId()) {
            return;
        }

        ReactGA.event({
            category: "engagement",
            action: "sign_up",
        });
    }

    static userLogin() {
        if (!this.hasCustomTrackingId()) {
            return;
        }

        ReactGA.event({
            category: "engagement",
            action: "login",
        });
    }
}
